import Walk from '../classes/WalkClass';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const selectors = {
  pamplemousse: '.js-pamplemousse-walk',
  step: '.js-pamplemousse-step',
};

const init = () => {
  const pamplemousses = document.querySelectorAll(selectors.pamplemousse);
  pamplemousses.forEach(pamplemousse => {
    if (!pamplemousse.classList.contains('is-initialized')) {
      pamplemousse.walk = new Walk(pamplemousse);
      pamplemousse.classList.add('is-initialized');
    };

    let velocity = 0;

    const onScrollStart = () => {
      pamplemousse.walk.walk(velocity);
    }

    const onScrollEnd = () => {
      pamplemousse.walk.stop();
    };

    let isScrolling = false;
    let scrollTimeout = null;
    const scrollThrottle = 200;
    window.lenis.on('scroll', e => {
      if (!document.body.matches('.is-loaded')) return;
      if (Math.abs(e.velocity) < 0.1) return;
      velocity = Math.min(Math.abs(e.velocity), 50) * 10;
      pamplemousse.walk.updateVelocity(velocity);

      if (!isScrolling) {
        isScrolling = true;
        onScrollStart();
      }

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        onScrollEnd();
      }, scrollThrottle);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
